/* eslint-disable no-underscore-dangle */
import listrakOrderTracking from './listrakOrderTracking'
import listrakEmptyCart from './listrakEmptyCart'
import submitCart from './submitCart'
import listrakProductBrowse from './listrakProductBrowse'

const Listrak = {
  submitCart,
  listrakProductBrowse,
  listrakOrderTracking,
  listrakEmptyCart,
}

export default Listrak
